/*
 * Luba Moden – Knopf „Anwenden" am Rabattcode-Feld (Devacon, 22.10.2026)
 * ----------------------------------------------------------------------
 * Prestige 11.4.1 wendet den Rabattcode nur beim Verlassen des Felds an (Event „change"),
 * Enter schickt das Warenkorb-Formular ab und führt direkt zur Kasse.
 * Diese Ergänzung:
 *   1. Klick auf [data-luba-rabatt-anwenden] wendet den Code an.
 *   2. Enter im Rabattfeld wendet den Code an, statt zur Kasse zu springen.
 * Angewendet wird immer über den Hersteller-Weg (change-Event an <cart-discount-field>),
 * Erfolg/Fehlermeldung kommen also unverändert aus theme.js. Doppelte Anfragen für
 * denselben Code (Klick + Verlassen des Felds) werden unterdrückt.
 * Event-Delegation am document, damit es auch nach dem Neuzeichnen der Schublade greift.
 * Rückbau: diese Datei, die Zeile in layout/theme.liquid und den Knopf in
 * snippets/cart-discount.liquid entfernen.
 */
(() => {
  if (window.lubaRabattAnwenden) return;
  window.lubaRabattAnwenden = true;

  const FELD = 'cart-discount-field input.input';
  const zuletzt = new WeakMap(); // Eingabefeld → zuletzt angewendeter Wert

  const anwenden = (input) => {
    const feld = input.closest('cart-discount-field');
    if (!feld || feld.getAttribute('aria-busy') === 'true') return;
    if (input.value.trim() === '') { input.focus(); return; }
    if (zuletzt.get(input) === input.value) return; // schon angewendet
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  // Jede Anwendung merken; ein zweites change mit demselben Wert (z. B. beim späteren
  // Verlassen des Felds) gar nicht erst an theme.js weitergeben.
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(FELD)) return;
    if (zuletzt.get(input) === input.value) { event.stopImmediatePropagation(); return; }
    zuletzt.set(input, input.value);
  }, true);

  document.addEventListener('click', (event) => {
    const knopf = event.target.closest('[data-luba-rabatt-anwenden]');
    if (!knopf) return;
    event.preventDefault();
    const input = knopf.closest('.cart-discount')?.querySelector(FELD);
    if (input) anwenden(input);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || event.isComposing) return;
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(FELD)) return;
    event.preventDefault(); // kein Absenden des Warenkorb-Formulars (= kein Sprung zur Kasse)
    anwenden(input);
  }, true);
})();
